import { BrowserModule } from '@angular/platform-browser';
import {ChangeDetectorRef,	Component,	ElementRef,	EventEmitter,  Input,  OnChanges, OnDestroy,
  OnInit,  Output,  SimpleChanges, ViewChild, AfterViewInit} from '@angular/core';
	//import Swal from 'sweetalert2';
	//import { of } from 'rxjs';
import {MapOptions} from '../../config/mapOptions';
//import { MouseEvent } from '@agm/core';

declare const google: any;
declare var $: any;
//declare var MarkerClusterer: any;	

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})
export class MapComponent implements OnInit {
	readonly options = MapOptions.map;
	readonly tools = MapOptions.tools;
	map: any;
	drawingMode:string;
	drawingManager: any;
	drawColor='blue';
	lat: number = 51.678418;
	lng: number = 7.809007;
	zoom:number = 8;
	
	tilesLoadedListener: any;
	 markers: marker[] = [
	  {
		  lat: 51.673858,
		  lng: 7.815982,
		  label: 'A',
		  draggable: true
	  },
	  {
		  lat: 51.373858,
		  lng: 7.215982,
		  label: 'B',
		  draggable: false
	  },
	  {
		  lat: 51.723858,
		  lng: 7.895982,
		  label: 'C',
		  draggable: true
	  }
  ];
   clickedMarker(label: string, index: number) {
    console.log(`clicked the marker: ${label || index}`)
  }
  initDrawingManager() {
    if (!this.drawingManager) {
      const options = {
        drawingControl: false, // custom drawing control
        markerOptions: this.tools.markerOptions,
        circleOptions: Object.assign(this.tools.circleOptions, {fillColor : this.drawColor}),
        polylineOptions: Object.assign(this.tools.polylineOptions, {strokeColor : this.drawColor}),
        rectangleOptions: Object.assign(this.tools.rectangleOptions, {fillColor : this.drawColor}),
        polygonOptions: Object.assign(this.tools.polygonOptions, {fillColor : this.drawColor}),
        drawingMode: this.drawingMode
      };
      this.drawingManager = new google.maps.drawing.DrawingManager(options);
      this.drawingManager.setMap(this.map);
      this.handleDrawingToolsEvent();
    }
  }
  mapClicked($event) {
    this.markers.push({
      lat: $event.coords.lat,
      lng: $event.coords.lng,
      draggable: true
    });
  }
  
  markerDragEnd(m: marker, $event: MouseEvent) {
    console.log('dragEnd', m, $event);
  }
	@ViewChild('mapContainer') mapContainer: ElementRef;
	@ViewChild("toolbar") toolbar: ElementRef;
	constructor() { }
	onMapReady(map) {
    this.map = map;
    this.tilesLoadedListener = this.map.addListener('tilesloaded', this.tiles_Loaded.bind(this));
    if (!this.drawColor) {
      this.drawColor = MapOptions.tools.colors[0];
    }
    this.initDrawingManager();
   // this.mapReady.emit(true);
    //this.initFeatures();
  }

  private tiles_Loaded() {
    //this.tilesLoaded.emit(this.map.tilesloading);
  }
	private handleDrawingToolsEvent() {
    
    this.drawingManager.addListener('overlaycomplete', (e) => {
      console.log(e);
      const shape = e.overlay; console.log(shape)
      /*shape.id = Utils.uniqueIdGenerator();
      shape.type = e.type;
      shape.all = false;
      shape.born = this.page.id;
      shape.pages = [this.page.id];      
      //
      shape.maker = 'DL';*/
     /* if((shape.type=== google.maps.drawing.OverlayType.POLYLINE)&&(shape.icons)){
        if(shape.getPath().j.length>2){
          const p = shape.getPath();
          for(let i=p.length-1; i>1; i--){
            if(i>1){
              p.removeAt(i);
            }
          }
        }
        let pt1= this.fromLatLngToPoint(shape.getPath().j[0]);
        let pt2= this.fromLatLngToPoint(shape.getPath().j[1]);
        let dis=Math.round(Math.sqrt(Math.pow((pt1.x-pt2.x) ,2) + Math.pow((pt1.y-pt2.y) ,2))); 
        if(dis<50){
          shape.setOptions({strokeWeight: 1});
        }else if(dis>100){
          shape.setOptions({strokeWeight: 3});
        }else{
          shape.setOptions({strokeWeight: 2});
        }
        console.log(dis);
        console.log(shape.strokeWeight);
          
        
        
      }*/
      // Switch back to non-drawing mode after drawing a shape.
      /*this.didDrawingModeChanged.emit({
        mode: null,
        counter: this.counter
      });
      shape.visible_ = google.maps.event.addListener(shape, 'visible_changed', (ee) => {
        // console.log('a');
      });
      // Add an event listener that selects the newly-drawn shape when the user mouses down on it.
      shape.dragstart_ = google.maps.event.addListener(shape, 'dragstart', () => {
        this.cm = false;
        this.ref.detectChanges();
      });
      shape.rightclick_ = google.maps.event.addListener(shape, 'rightclick', (event) => {
        event.wa.preventDefault();
        event.wa.stopPropagation();
        this.clearSelection();
        shape.setEditable(true);
        this.currentShape = shape;
        this.shapeSelected.emit(this.currentShape);
        this.cm = shape;
        const  position = this.fromLatLngToPoint(event.latLng);
        this.cmStyle = {
          top: position.y + 62 + 'px',
          left: position.x + 46 + 'px'
        };
        this.ref.detectChanges();
      });
      shape.click_ = google.maps.event.addListener(shape, 'click', (event) => {
        if (event.vertex !== undefined) {console.log(event.vertex)
          if (shape.type === google.maps.drawing.OverlayType.POLYGON) {
            const p = shape.getPaths().getAt(event.path);
            p.removeAt(e.vertex);
            if (p.length < 3) {
              shape.setMap(null);
            }
          }
          if (shape.type === google.maps.drawing.OverlayType.POLYLINE) {
            const p = shape.getPath();
            p.removeAt(event.vertex);
            if (p.length < 2) {
              shape.setMap(null);
            }
          }
        }
        this.clearSelection();
        shape.setEditable(true);
        this.currentShape = shape;
        this.cm = shape;
        this.shapeSelected.emit(this.currentShape);
		
      });
      // set currently shape selected
      this.clearSelection();
      this.currentShape = shape;
      this.currentShape.setEditable(true);
      this.shapeSelected.emit(this.currentShape);
      this.reportService.shapes.push(shape); console.log(this.reportService.shapes)*/
    });
  
  }
  onMapZoomChange(zoom: number) { //console.log(zoom)
   // this.cm = false;
   // this.zoom = zoom;
    
   // this.zoomChange.emit(this.zoom.toString());
    
  }
	ngOnInit(): void {
		
		
		
		
		
	}
	ngAfterViewInit(){

	}
	showTool(){
	this.toolbar.nativeElement.style.visibility = 'visible';  
  }
  hideTool(){
	this.toolbar.nativeElement.style.visibility = 'hidden';
  }
  changeDrawingMode(mode: string) {console.log(mode);
    this.drawingMode = mode;
   /* this.drawingModeChanged.emit({
      mode: this.drawingMode,
      counter: +(new Date())
    });*/
	let lineSymbol = {
      path: 'M 0,-1 0,1',
      strokeOpacity: 1,
     // scale: 4,
    };
    /*if (clearSelection) {
      this.clearSelection();
    }*/
    if (this.drawingManager) {
      switch (this.drawingMode) {
        case 'hand':
			this.drawingMode = null;
          break;
    case 'agmMarker':
      this.drawingMode = null;
      break;
		case 'arrow':
      this.drawingMode = 'polyline';
      //if(this.selectedLineStyle=="line"){
        this.drawingManager.set('polylineOptions', Object.assign(this.drawingManager.get('polylineOptions'), {icons: [{
          icon: {path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW},
          offset: '100%'}],strokeWeight:2,strokeOpacity:1}));
     /* }else if(this.selectedLineStyle=="dash"){
        this.drawingManager.set('polylineOptions', Object.assign(this.drawingManager.get('polylineOptions'), {icons: [{
          icon: {path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW, strokeOpacity:1,strokeWeight:parseInt(this.selectedArrowWeight)}},{
          icon: lineSymbol,offset: '0',repeat: '30px',scale:parseInt(this.selectedArrowWeight)}],strokeWeight:parseInt(this.selectedArrowWeight),strokeOpacity:0}));
      } */
		
      //this.drawingManager.set('polylineOptions', Object.assign(this.drawingManager.get('polylineOptions'), {stokeWeight:7}));
      //console.log(this.drawingManager.polylineOptions)
			break;
        
    default:
      //if(this.selectedLineStyle=="line"){
        this.drawingManager.set('polylineOptions', Object.assign(this.drawingManager.get('polylineOptions'), {icons: null,strokeWeight:3,strokeOpacity:1}));
      /*}else if(this.selectedLineStyle=="dash"){
        this.drawingManager.set('polylineOptions', Object.assign(this.drawingManager.get('polylineOptions'), {icons: [{
          icon: lineSymbol,offset: '0',repeat: '20px'}],strokeWeight:3,strokeOpacity:0}));
      } */
		   // this.drawingManager.set('polylineOptions', Object.assign(this.drawingManager.get('polylineOptions'), {icons: null,strokeWeight:3}));
          break;
      }
      this.drawingManager.setDrawingMode(this.drawingMode);
    }
  }
  mapResize(event){
	  event.stopPropagation();
	  console.log($(event.target).val());
	  let newHeight=$(event.target).val()+'px';
	  console.log($(".googleMap"));
	  console.log($("#mapContainer"));
	  $("#mapContainer").parent().css('height',newHeight);
	 // $(".googleMap").css('height',newHeight);
	  /*this.map.addListener(
	   google.maps.event.addListener(map, "idle", function()
        {
            google.maps.event.trigger(map, 'resize');
        });*/
	  //this.map.triggerResize();
	  console.log($(".googleMap"));
	  console.log($("#mapContainer"));
	  //this.map.triggerResize();
	  /*window.setTimeout(function(){
    google.maps.event.trigger(this.map, 'resize');
},100);*/
  }
}
interface marker {
	lat: number;
	lng: number;
	label?: string;
	draggable: boolean;
}